
import React from "react";
import NewUserWelcome from "@/components/Welcome/NewUserWelcome";

interface EmptyProjectsStateProps {
  onCreateProject: (name: string) => Promise<void>;
  onCreateSampleProject: () => Promise<void>;
  onProjectSelect?: (projectId: string) => void;
  onFolderSelect?: (folderId: string) => void;
}

const EmptyProjectsState: React.FC<EmptyProjectsStateProps> = ({ 
  onCreateProject, 
  onCreateSampleProject,
  onProjectSelect,
  onFolderSelect
}) => {
  return (
    <NewUserWelcome 
      onCreateProject={onCreateProject}
      onCreateSampleProject={onCreateSampleProject}
      onProjectSelect={onProjectSelect}
      onFolderSelect={onFolderSelect}
    />
  );
};

export default EmptyProjectsState;
